"use client";

import { getSiteProps } from "@/utils";
import { memo } from "react";

import { getPersonalDetails } from "@/components/profile/contactCard/query";
import { getProfileStats } from "@/components/profile/profileScore/utils/query";
import { ProfileStatsApiType } from "@/components/profile/profileScore/utils/types";

import CustomHeader from "./components/customHeader";
import Skeleton from "./components/skeleton";
import { getHeaderData } from "./query";
import {
  HeaderApiData,
  HeaderWithLoadingProps,
  UserDataResponseType,
  personalDetailType,
} from "./types";

const HeaderWithLoading: React.FC<HeaderWithLoadingProps> = (props) => {
  const { isMobile, isLoggedIn, host, pathName, isApp } = props;

  const siteProps = getSiteProps(host);
  const apiEndpoint = siteProps?.api_url || "";

  const { isLoading, isError, data } = getPersonalDetails();
  const profile = getProfileStats();
  const header = getHeaderData(apiEndpoint);

  if (profile?.isLoading || header.isLoading || isLoading) {
    return isMobile ? null : <Skeleton />;
  }

  if (profile?.isError || header?.isError || isError) {
    return <div>Error loading data. Please try again later.</div>;
  }

  if (!header || !profile || !data) return null;

  const personalData = data?.personalDetailSection as personalDetailType;
  const profileStatsTyped = profile?.data as ProfileStatsApiType;
  const headerTyped = header?.data?.data as HeaderApiData;

  const headerInfo: UserDataResponseType = {
    userProfileScore: profileStatsTyped?.profileScore || 0,
    userCompanyName: profileStatsTyped?.currentCompany || null,
    userDesignation: profileStatsTyped?.currentDesignation || null,
    cartCount: headerTyped?.cartCount || 0,
    notificationCount: headerTyped?.notificationCount || 0,
    kiwiUserId: personalData?.personalDetails?.kiwiUserId || 0,
    userName: headerTyped?.userName || "",
    userProfileImage: headerTyped?.userProfileImage || "",
  };

  const pathNameInCustomHeader = {
    "/profile": "Profile",
    "/dashboard": "Dashboard",
  };

  return (
    <CustomHeader
      host={host}
      isLoggedIn={isLoggedIn}
      isMobile={isMobile}
      isApp={isApp}
      authUserData={headerInfo}
      hamburgerData={null}
      pathName={
        pathNameInCustomHeader[
          pathName as keyof typeof pathNameInCustomHeader
        ] ?? "Home"
      }
    />
  );
};

export default memo(HeaderWithLoading);
